import PropertyListerView from '../view'
import {PolarCoord, getZoomLevel} from './utils'
import HTML from '../../../../html'
import {imagesToSvg} from '../../../../utils'
import sharedData from '../../../../shared-data'
import events from '../../../../event-emitter'


export default class PropertyMapView extends PropertyListerView {
    
    constructor(controller) {
        super(controller)
    }
    
    multiMarkerMap() {
        
        var mapRoot = HTML('div').classes('prop-view-map').render()
        var googleMap
        
        /*
         * One might ask, why some of the features of Google API for center and zoom calculations are not used?
         * Because they are yielding worse results!
         */
        
        let initMap = () => {
            googleMap = new google.maps.Map(mapRoot, {
                styles: sharedData.googleMap.style,
            })
            
            const createPin = text => {
                let svg = `
        <svg version="1.1" id="layer" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 46 18" xml:space="preserve">
          <style type="text/css">
            .st0{fill:#781519;}
            .text{font-family:MittelschriftAusD,sans-serif;font-size:6px;text-align:center;}
          </style>
          <g id="dot">
            <circle class="st0" cx="23" cy="5" r="5"/>
          </g>
          <text id="text" text-anchor="middle" x="23" y="18" class="text">${text}</text>
        </svg>
        `.trim()
                return `data:image/svg+xml,` + svg
            }
            
            let infoWindows = []
            let closeInfoWindows = () => infoWindows.forEach(w => w.close())
            
            let markers = this.controller.props.projekts.map(projekt => {
                let content = this.projektCard(projekt)
                let clickButton = `<a class="projekt-more-info" href="${projekt.permalink}">Klicka för att läsa mer</a>` // Visual aid for users
                
                let projektCardInfoWindow = new google.maps.InfoWindow({
                    content: content + clickButton,
                })
                infoWindows.push(projektCardInfoWindow)
                
                let gmarker = new google.maps.Marker({
                    position: new PolarCoord(projekt.coordinates.latitude, projekt.coordinates.longitude),
                    map: googleMap,
                    // title: "Klicka för att läsa om projektet",
                    title: projekt.name,
                    animation: google.maps.Animation.DROP,
                    icon: sharedData.googleMap.projektIcon,
                    // icon: createPin(projekt.name),
                    // icon: new google.maps.MarkerImage(createPin(projekt.name), null, null, null, new
                    // google.maps.Size(120, 120 * (36 / 92))),
                })
                
                gmarker.addListener('click', () => {
                    closeInfoWindows()
                    projektCardInfoWindow.open(googleMap, gmarker)
                    imagesToSvg('.finder img.replace-with-svg')
                    infoWindowOpened = true
                })
                
                // Do not show prompt on hover when infoWindow is open
                let infoWindowOpened = false
                projektCardInfoWindow.addListener('closeclick', () => {
                    infoWindowOpened = false
                })
                
                let clickMeWindow = new google.maps.InfoWindow({
                    content: `<span class="gmap-click-prompt">Klicka för att läsa om ${projekt.name}</span>`,
                })
                
                google.maps.event.addListener(gmarker, 'mouseover', () => {
                    if (!infoWindowOpened && document.body.classList.contains('not_device')) {
                        clickMeWindow.open(googleMap, gmarker)
                    }
                })
                google.maps.event.addListener(gmarker, 'mouseout', () => {
                    clickMeWindow.close()
                })
                
                return gmarker
            })
            // Add a marker clusterer to manage the markers.
            let markerCluster = new MarkerClusterer(googleMap, markers, {
                // imagePath: window.wpEnvironment.templateUrl + '/images/clusterer/cluster',
                styles: [
                    {
                        textColor: '#ffffff',
                        url: window.wpEnvironment.templateUrl + '/assets/images/clusterer/cluster21.png',
                        height: 53,
                        width: 53,
                    },
                ],
            })
        }
        
        var mapUpdate = () => {
            if (!sharedData.googleMap.JSAPILoaded) {
                return
            }
            
            var realPolarBoundaries = this.controller.props.projekts.reduce((current, next) => {
                if (next.coordinates.latitude < current.lowest) {
                    current.lowest = next.coordinates.latitude
                }
                if (next.coordinates.latitude > current.highest) {
                    current.highest = next.coordinates.latitude
                }
                if (next.coordinates.longitude < current.leftmost) {
                    current.leftmost = next.coordinates.longitude
                }
                if (next.coordinates.longitude > current.rightmost) {
                    current.rightmost = next.coordinates.longitude
                }
                return current
            }, {
                lowest: 90,
                highest: -90,
                leftmost: 180,
                rightmost: -180,
            })
            
            var corner1 = new PolarCoord(realPolarBoundaries.lowest, realPolarBoundaries.leftmost)
            var corner2 = new PolarCoord(realPolarBoundaries.highest, realPolarBoundaries.rightmost)
            
            var boundariesPolarDelta = {
                dlat: realPolarBoundaries.highest - realPolarBoundaries.lowest,
                dlng: realPolarBoundaries.rightmost - realPolarBoundaries.leftmost,
            }
            
            setTimeout(() => {
                var elementSize = {
                    width: mapRoot.clientWidth,
                    height: mapRoot.clientHeight,
                }
                
                var midpoint = corner1.midpoint(corner2)
                var zoomLevel = getZoomLevel(elementSize, boundariesPolarDelta, midpoint, 15)
                
                google.maps.event.trigger(googleMap, 'resize')
                
                googleMap.setCenter(midpoint)
                googleMap.setZoom(zoomLevel)
                
                events.removeListener('writeContent', mapUpdate)
            }, 1)
        }
        
        events.on('writeContent', mapUpdate)
        
        if (!sharedData.googleMap.JSAPILoaded) {
            if (sharedData.googleMap.JSAPIEmbedded) {
                return
            }
            let script = HTML('script')
                .attr({ src: 'https://maps.googleapis.com/maps/api/js?key=' + sharedData.googleMap.apiKey })
                .on('load', () => {
                    let clusters = HTML('script')
                        .attr({ src: window.wpEnvironment.templateUrl + '/assets/images/clusterer/markerclusterer.js' })
                        .on('load', () => {
                            sharedData.googleMap.JSAPILoaded = true
                            initMap()
                            mapUpdate()
                        }).render()
                    window.document.body.appendChild(clusters)
                }).render()
            window.document.body.appendChild(script)
            sharedData.googleMap.JSAPIEmbedded = true
        } else {
            initMap()
            mapUpdate()
        }
        
        return HTML('div')
            .attr({ style: 'position: relative' })
            .append(
                HTML('div')
                    .classes('abolute-fitter')
                    .attr({
                        onclick: "style.pointerEvents = 'none'",
                        style: "pointer-events: auto; z-index: 5;"
                    })
                    .render(),
                mapRoot
            ).render();
    }
    
}
